import { jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from '@coolblue-development/freddy';
import { useStoreAvailability } from '../../../context/StoreAvailabilityContext.js';
export const StoreAddress = () => {
    const { store } = useStoreAvailability();
    if (!(store === null || store === void 0 ? void 0 : store.address)) {
        return null;
    }
    const { address } = store;
    return (_jsxs(Typography, { mb: 0, variant: "body", children: [address.street, " ", address.houseNumber, address.houseNumberAddition, ", ", address.postalCode, " ", address.city] }));
};
//# sourceMappingURL=StoreAddress.js.map